import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { STRIPE_ASSETS, STRIPE_DISCLOSURE_TEXT } from '../../../v2-layout/stripe-treasury/stripe-treasury.constants';

export interface BankAccountKycDialogResult {
    startVerification: boolean;
}

@Component({
    selector: 'app-bank-account-kyc-dialog',
    standalone: true,
    templateUrl: './bank-account-kyc-dialog.component.html',
    styleUrls: ['./bank-account-kyc-dialog.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BankAccountKycDialogComponent {
    @Input() open = false;
    @Output() readonly closed = new EventEmitter<BankAccountKycDialogResult>();

    readonly stripeWordmark = STRIPE_ASSETS.WORDMARK;
    readonly disclosureText = STRIPE_DISCLOSURE_TEXT.PARTNER_DISCLOSURE;
}
